// Türkçe çeviri sözlüğü — nokta-yollu anahtarlarla (ör. "common.close") okunur, bkz. LanguageContext.jsx.
export default {
  common: {
    close: 'Kapat',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    refresh: 'Yenile',
    loading: 'Yükleniyor…',
    understood: 'Anladım, kapat',
    yes: 'Evet',
    no: 'Hayır',
    test: 'Test',
    spot: 'Spot',
    futures: 'Vadeli',
    long: 'Long',
    short: 'Short',
    logout: 'Çıkış',
    settings: 'Ayarlar',
    help: 'Yardım',
    apply: 'Uygula',
    back: 'Geri',
    error: 'Hata',
    success: 'Başarılı',
  },
  app: {
    twoFactor: '2FA',
    menu: 'Menü',
    wsConnected: 'Canlı',
    wsConnecting: 'Bağlanıyor…',
    wsError: 'Hata',
    wsReconnecting: 'Yeniden Bağlanıyor…',
    logs: 'Loglar',
    backtest: 'Backtest',
    support: 'Destek',
    help: 'Yardım',
    settings: 'Ayarlar',
    logout: 'Çıkış',
    langButtonTitle: 'Dil değiştir',
    themeButtonTitle: 'Tema değiştir',
    eventBotStarted: '🤖 Bot Başlatıldı',
    eventBotStopped: '⏹ Bot Durduruldu',
    eventTradeOpened: '✅ İşlem Açıldı',
    eventTradeClosedProfit: '💰 İşlem Kapandı (Kâr)',
    eventTradeClosedLoss: '📉 İşlem Kapandı (Zarar)',
    eventSlCooldown: '⏸ SL Koruması Aktif',
    eventSlCooldownDetail: '{symbol} — {min} dk yeni işlem yok',
    eventSignalSkipped: '⏭ Sinyal Atlandı',
    eventError: '❌ Hata',
    errStartFailed: 'Başlatılamadı',
    errStopFailed: 'Durdurulamadı',
    errCloseFailed: 'Kapatılamadı',
    errOpenFailed: 'İşlem açılamadı',
    errTpSlFailed: 'TP/SL güncellenemedi',
  },
  backtest: {
    title: 'Backtest',
    interval1m: '1dk',
    interval5m: '5dk',
    interval15m: '15dk',
    interval30m: '30dk',
    tabRun: 'Tekli Test',
    tabSweep: 'Parametre Taraması',
    tabWalkforward: 'Walk-Forward',
    tabHistory: 'Geçmiş',
    pair: 'Parite',
    pairPlaceholder: 'örn: BTCUSDT',
    period: 'Periyot',
    strategy: 'Strateji',
    startDate: 'Başlangıç Tarihi/Saati',
    endDate: 'Bitiş Tarihi/Saati',
    initialCapital: 'Başlangıç Sermaye',
    marginPerTrade: 'Marjin / İşlem',
    leverage: 'Kaldıraç',
    feeRate: 'Komisyon Oranı',
    feeRateUnit: 'oran',
    rankMetric: 'Sıralama Metriği',
    rankMetricTrain: 'Sıralama Metriği (train seçiminde kullanılır)',
    rankTotalPnl: 'Toplam PnL',
    rankWinRate: 'Kazanma Oranı',
    rankProfitFactor: 'Profit Factor',
    rankExpectancy: 'Beklenti/İşlem',
    rankMaxDrawdown: 'Maks. Drawdown (düşük=iyi)',
    fieldHmaPeriod: 'HMA Periyodu',
    fieldAdxPeriod: 'ADX Periyodu',
    fieldAdxThreshold: 'ADX Eşiği',
    fieldBoxMult: 'Box Çarpanı (×ATR)',
    fieldRsiDeadzone: 'RSI Ölü Bölge (±puan)',
    fieldPullbackMult: 'Pullback Mesafesi (×ATR)',
    fieldRsiTrigger: 'RSI Momentum Eşiği',
    fieldAtrPeriod: 'ATR Periyodu',
    fieldSlMult: 'SL Çarpanı (×ATR)',
    fieldSlPct: 'SL %',
    fieldTpPct: 'TP %',
    fieldChopPeriod: 'CHOP Periyodu',
    fieldChopThreshold: 'CHOP Eşiği',
    fieldMinRR: 'Min. Ödül:Risk',
    fieldMaxDailyLoss: 'Günlük Kayıp Limiti %',
    gridHint: 'Boş bırakılan alanlar taranmaz. Değerleri virgülle ayırarak birden fazla girin (örn: 9,14,21).',
    gridPlaceholder: 'Örn: {ex}',
    runButton: '▶ Backtest Çalıştır',
    running: 'Çalışıyor…',
    sweepButton: '▶ Taramayı Çalıştır',
    sweeping: 'Taranıyor…',
    walkforwardButton: '▶ Walk-Forward Çalıştır',
    trainWindow: 'Train Penceresi (gün)',
    testWindow: 'Test Penceresi (gün)',
    errNoParam: 'En az bir parametre için değer girin',
    errNoStrategy: 'Lütfen önce bir strateji seçin',
    emptyTrades: 'İşlem yok.',
    csvDownload: '⬇ CSV İndir',
    visualizeTitle: 'İşlemi görselleştir (gerçek OKX verisiyle)',
    colEntry: 'Giriş',
    colSide: 'Yön',
    colEntryPrice: 'Giriş Fiyatı',
    colExit: 'Çıkış',
    colExitPrice: 'Çıkış Fiyatı',
    colPnl: 'P&L',
    colBalance: 'Bakiye',
    colReason: 'Sebep',
    colConfig: 'Config',
    colTrades: 'İşlem',
    colWinRate: 'Kazanma',
    colMaxDD: 'Maks DD',
    colDetail: 'Detay',
    colClose: 'Kapat',
    default: '(varsayılan)',
    metricTrades: 'İşlem Sayısı',
    metricWinRate: 'Kazanma Oranı',
    metricTotalPnl: 'Toplam PnL',
    metricFinalEquity: 'Kalan Bakiye',
    metricReturn: 'Getiri',
    metricProfitFactor: 'Profit Factor',
    metricMaxDrawdown: 'Maks. Drawdown',
    metricExpectancy: 'Beklenti/İşlem',
    metricTotalFees: 'Toplam Komisyon',
    bankruptWarning: '⚠ Hesap tükendi — {date} itibarıyla bakiye yeni işlem için gereken marjini karşılayamadı, bu andan sonra yeni işlem açılmadı (açık pozisyon varsa doğal sonuna kadar devam etti).',
    help: '❓ Yardım',
    verifyDataButton: '✓ OKX Verisiyle Doğrula (deterministik)',
    verifying: 'Doğrulanıyor…',
    verifySummary: '{ok}/{total} işlem mum aralığına uygun',
    verifyMismatch: ' — {n} tutarsız',
    historyTitle: "Geçmiş Backtest'ler",
    verifyLogs: '📋 Doğrulama Logları',
    deleteSelected: '🗑 Seçilenleri Sil ({n})',
    deleteAll: '🗑 Tümünü Sil',
    deleteFiltered: '🗑 Filtrelenenleri Sil ({n})',
    refresh: '↻ Yenile',
    emptyHistory: 'Henüz kayıtlı backtest yok.',
    emptyHistoryFiltered: 'Filtreyle eşleşen kayıt yok.',
    filterAllSymbols: 'Tüm Pariteler',
    filterAllStrategies: 'Tüm Stratejiler',
    filterClear: '✕ Filtreyi Temizle',
    filterDateFrom: 'Başlangıç:',
    filterDateTo: 'Bitiş:',
    filterPnlPlaceholder: 'Değer',
    colDate: 'Tarih',
    colSymbol: 'Sembol',
    colStrategyShort: 'Strateji',
    colRange: 'Aralık',
    loading: 'Yükleniyor…',
    notSingleTestNote: 'Bu kayıt bir parametre taraması/walk-forward sonucu — detay için ilgili sekmeden tekrar çalıştırın.',
    deleteConfirm: '{label} silinecek. Emin misiniz?',
    deleteConfirmAll: 'tüm backtest geçmişi',
    deleteConfirmSelected: '{n} kayıt',
    walkWindow: 'Pencere',
    walkAvgInSample: 'Ort. In-Sample',
    walkAvgOutOfSample: 'Ort. Out-of-Sample',
    walkOverfitRatio: 'Overfit Oranı',
    walkOosPositive: 'OOS Pozitif Pencere',
    walkOverfitHint: "Overfit oranı 1'e yakınsa train/test performansı tutarlı. Çok düşük veya negatifse strateji geçmişe aşırı uymuş olabilir.",
    colTrainRange: 'Train Aralığı',
    colTestRange: 'Test Aralığı',
    colSelectedConfig: 'Seçilen Config',
    colInSamplePnl: 'In-Sample PnL',
    colOutOfSamplePnl: 'Out-of-Sample PnL',
    colOosWinRate: 'OOS Kazanma',
    verifLogsTitle: 'Doğrulama Logları (OKX veri-bazlı, deterministik)',
    verifLogsEmpty: 'Henüz doğrulama kaydı yok — bir backtest\'in "Detay" görünümünde "OKX Verisiyle Doğrula" butonunu kullanın.',
    verifLogsAllOk: '✓ Hepsi mum aralığına uygun',
    verifLogsFail: '⚠ {n} tutarsız işlem',
    verifLogsRecords: '{n} kayıt',
    colBacktest: 'Backtest',
    colEntryTime: 'Giriş Zamanı',
    colCandleRange: 'Mum Aralığı',
    colFits: 'Uygun',
    colExitTime: 'Çıkış Zamanı',
    invalidServerResponse: 'Sunucudan geçersiz bir yanıt geldi (HTTP {status}) — muhtemelen istek zaman aşımına uğradı (çok geniş bir tarih aralığı + ince periyot seçilmiş olabilir) ya da sunucu geçici olarak erişilemez durumda. Daha kısa bir aralık veya daha kaba bir periyot (5m/15m) deneyip tekrar dene.',
    serverError: 'Sunucu hatası (HTTP {status})',
  },
  settings: {
    title: 'Ayarlar',
    tabGeneral: 'Genel',
    tabApi: 'API',
    tabUsers: 'Kullanıcılar',
    tabSignal: 'Sinyal',
    tabRisk: 'Risk',
    tabWallet: 'Cüzdan',
    tabSms: 'SMS',
    tabSecurity: 'Güvenlik',
    tabBackups: 'Yedekler',
    utcOffset: 'Saat Dilimi (UTC)',
    utcOffsetHint: 'Grafik mum zamanları, backtest tarih girişi/çıkışı ve işlem anlatımı bu saat dilimine göre gösterilir.',
    loadFailed: 'Ayarlar yüklenemedi',
    saveFailed: 'Kayıt hatası',
    exchangeSwitchBlocked: 'Aktif bir botunuz veya açık işleminiz varken borsa (Base URL) değiştirilemez. Önce botları durdurun / işlemleri kapatın.',
    okxWithdrawPermission: 'Bu API anahtarında "Para Çekme" yetkisi açık — güvenliğiniz için kabul edilmez. OKX\'te yalnızca "Okuma" ve "İşlem" yetkili yeni bir anahtar oluşturup onu girin.',
    saved: 'Ayarlar kaydedildi',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    apiKey: 'API Key',
    secretKey: 'Secret Key',
    passphrase: 'Passphrase',
    baseUrl: 'Base URL',
    apiNote: 'API anahtarları değiştirildiğinde mevcut bağlantılar hemen güncellenir.',
    secretPlaceholder: '(değiştirmek için girin)',
    riskNote: 'SL açılışta belirlenir ve değişmez.',
    riskHelp: '? Yardım',
    fieldSlPct: { label: 'SL Yüzdesi', hint: '0 = ATR kullan  |  >0 = girişten sabit fiyat hareketi (örn: 0.75). SL giriş sonrası değişmez.' },
    fieldSlPctPctOnly: { hint: '0 veya boş = SL KAPALI (bu stratejide ATR yedek sigortası yoktur — dikkatli kullanın). >0 = girişten sabit yüzde zarar sınırı, giriş sonrası değişmez.' },
    fieldTpPct: { label: 'TP Yüzdesi', hint: '0 veya boş = TP kapalı (pozisyon yalnızca SL veya yapısal çıkışla kapanır). >0 = girişten sabit yüzde kâr hedefi.' },
    fieldAtrPeriod: { label: 'ATR Periyodu', hint: 'ATR hesaplama uzunluğu (önerilen: 14)' },
    fieldAtrSlMult: { label: 'SL Çarpanı (ATR)', hint: 'SL = Giriş ± N × ATR — SL% > 0 ise devre dışı. SL giriş sonrası sabit kalır, hiç değişmez.' },
    fieldSlCooldown: { label: 'SL Cooldown', hint: 'Stop loss tetiklenince bu süre yeni işlem açılmaz' },
    fieldChopPeriod: { label: 'CHOP Periyodu', hint: 'Rejim filtresi (Choppiness Index) hesaplama uzunluğu. Tüm stratejilerde geçerlidir.' },
    fieldChopThreshold: { label: 'CHOP Eşiği', hint: 'Varsayılan 61.8 (AÇIK) — piyasa bu değerin üzerinde yatayken (choppy) hiç işlem açılmaz. 0 = devre dışı. Klasik değerler: 38.2 / 50 / 61.8' },
    fieldHmaPeriod: { label: 'HMA Periyodu', hint: 'Hull MA hesaplama uzunluğu. Küçük değer daha hızlı yön değişimi, büyük değer daha yavaş/az sinyal.' },
    fieldAdxPeriod: { label: 'ADX Periyodu', hint: 'ADX hesaplama uzunluğu.' },
    fieldAdxThreshold: { label: 'ADX Eşiği', hint: '0 = devre dışı. HMA/Trend-Pullback: >0 ise trend yönü VE ADX ≥ eşik ikisi birden aranır — aynı eşik kapanış/trend-geçersizleşme kararında da geçerlidir.' },
    fieldRangeBoxMult: { label: 'Box Çarpanı', hint: 'Yalnızca Range Bar + HMA + ADX. Range bar kutu (box) büyüklüğü = ATR × bu çarpan.' },
    fieldRsiDeadzone: { label: 'RSI Ölü Bölge', hint: '0 = devre dışı. SMA-50\'de HEM giriş bandını HEM çıkış eşiğini belirler — ikisi birbirinin tam simetriğidir, ama giriş KOŞULSUZ değildir: SMA önce bu banda uğramalı, bandın dışına ÇIKTIĞI anda açılır; içine dönünce kapanır. RSI+SMA\'da ise SMA etrafında bir YÖN DEĞİŞTİRME tamponudur (giriş koşulsuz, sadece flip bu kadar gecikir).' },
    fieldPullbackMult: { label: 'Pullback Mesafesi', hint: 'Yalnızca Trend-Pullback+R. Giriş için fiyatın MA50\'ye izin verilen uzaklığı — bunun dışındaysa (fiyat "uzamış") işlem açılmaz. Varsayılan: 1.0' },
    fieldRsiTrigger: { label: 'RSI Momentum Eşiği', hint: 'Yalnızca Trend-Pullback+R. LONG için RSI ≥ bu değer, SHORT için RSI ≤ (100−bu değer) momentum onayı arar. Varsayılan: 45' },
    fieldMinRR: { label: 'Min. Ödül:Risk Oranı', hint: '0 = devre dışı. >0 ise bu orandan düşük TP:SL oranına sahip işlemler açılmaz (örn: 1.5).' },
    fieldMaxDailyLoss: { label: 'Günlük Kayıp Limiti', hint: '0 = devre dışı. >0 ise margin\'in bu yüzdesi kadar günlük kayıp sonrası o gün yeni işlem açılmaz. Açık pozisyonları etkilemez.' },
    strategySelectTitle: 'Analiz Stratejisi',
    strategySelectHint: 'Bot sinyallerini ve dinamik TP/kapatma kararlarını belirler.',
    showHmaIndicator: 'HMA İndikatör',
    showAdxIndicator: 'ADX İndikatör',
    indicatorHint: 'Grafikte çizilsin mi? Varsayılan kapalıdır — MA50/MA200/RSI/SMA her zaman çizilir, HMA ve ADX yalnızca burada işaretlenirse grafiğe eklenir.',
  },
  monitorPanel: {
    botRunningTitle: 'Bot çalışıyor — durdurmak için "Durdur" butonunu kullan',
    watchingTitle: 'Açık işlem izleniyor',
    closeTraceTitle: 'İzlemeyi Durdur',
    stopBot: '■ {symbol} Durdur',
    stopWatching: '■ İzlemeyi Durdur',
    manualTrade: 'Manuel İşlem',
    long: '▲ Long',
    short: '▼ Short',
    longTest: '▲ Long (Test)',
    shortTest: '▼ Short (Test)',
    spotStart: '▶ Al',
    spotStartTest: '▶ Al (Test)',
    spotSell: '⏹ Sat',
    close: '⏹ Kapat',
    demoModeBlocked: 'Demo modda manuel işlem açılamaz',
    alreadyOpenManual: 'Manuel işlem zaten açık',
    alreadyOpenBot: 'Bot işlem zaten açık',
    simulationHint: 'Gerçek işlem açmadan simülasyon',
    closeManualTitle: 'Açık manuel işlemi anında (piyasa fiyatından) kapat',
    slLabel: 'SL',
    tpLabel: 'TP',
    priceMode: 'Fiyat',
    amountMode: 'Tutar',
    defaultUsedHint: 'Boş bırakılırsa hesap varsayılanı kullanılır',
    period: 'Periyot',
    periodLockHint: 'Bot bu periyotla başlayıp ömrü boyunca bu periyotta kalır',
    starting: 'Başlatılıyor…',
    startBot: '▶ {symbol} Başlat ({interval})',
    startBotTest: '▶ {symbol} Başlat (Test, {interval})',
    openedMsg: '{side} açıldı',
    closedMsg: 'İşlem kapatıldı',
  },
  botControl: {
    greeting: 'Merhaba,',
    greetingName: 'Sayın {name}',
    activeExchange: 'Aktif Borsa',
    activeExchangeNone: '-',
    activeExchangeInvalid: 'Geçersiz API Bilgileri',
    activeExchangeHelpTooltip: 'Ayarlardan API bilgilerini giriniz',
    activeExchangeWithdrawWarning: 'API anahtarınızda "Para Çekme" yetkisi açık. Anahtar sızarsa bakiyeniz çekilebilir — OKX\'te yalnızca "Okuma" ve "İşlem" yetkili yeni bir anahtar oluşturup Ayarlar\'dan değiştirin.',
    title: 'Bot Ayarları',
    viewerBadge: 'Salt Okunur Mod',
    noActiveBots: 'Aktif bot yok.',
    activeBots: 'Aktif Botlar',
    running: 'Çalışıyor',
    market: 'Piyasa',
    spot: 'Spot',
    futures: 'Vadeli',
    futuresDisabledOkxTr: 'OKX TR vadeli işlem sunmuyor — sadece Spot kullanılabilir.',
    pair: 'Parite',
    pairPlaceholder: 'örn: AXSUSDT',
    quantity: 'Miktar',
    margin: 'Marjin',
    leverageLabel: 'Kaldıraç — seçili: {leverage}x',
    demoModeTitle: 'Demo Mod',
    demoModeText: 'İzle (4 parite) ve Test Botu kullanabilirsiniz. Gerçek işlem için abonelik gereklidir.',
    runningInfo: '{symbol} çalışıyor',
    maxPairsTitle: 'Maksimum {max} parite takip edilebilir',
    updateTraceTitle: 'Marjin/kaldıraç ayarlarını güncelle',
    startTraceTitle: 'Takibi başlat — sekmeden bot veya manuel işlem aç',
    traceButton: '👁 İzle',
    subscribeButton: 'Abone Ol',
    stopSuccess: '{symbol} botu durduruldu',
    stopButton: 'Durdur',
    openManualTrades: 'Açık Manuel İşlemler',
    entryLabel: 'Giriş',
    slNone: '—',
    tpNone: 'yok',
    closeButton: 'Kapat',
    closeButtonSpot: 'Sat',
    ruleRsimaEntry: 'Giriş koşulsuz/anlık: RSI vs SMA yönü — TP yok, sadece SL',
    ruleRsimaFlip: 'SMA±ÖlüBölge tamponu geçince kapat+flip aynı anda',
    ruleRsima50Entry: 'Giriş: SMA önce Ölü Bölge\'ye (50±{dz}) uğramalı — bandın dışına çıktığı mum kapanışında LONG/SHORT açılır',
    ruleRsima50Exit: 'SMA Ölü Bölge\'ye dönene kadar açık kalır, dönünce kapanır — TP yok, sadece SL',
    ruleTrendPullback: 'MA50/MA200 trend + Pullback:{pb}×ATR + RSI≥{rt}',
    ruleThresholdLabel: 'Eşik:{v}',
    ruleThresholdOffLabel: 'Eşik:kapalı',
    ruleAdxThresholdLabel: 'ADX Eşiği:{v}',
    ruleAdxThresholdOffLabel: 'ADX Eşiği:kapalı',
    ruleNoFixedTp: 'Sabit TP yok, sadece SL (yedek sigorta) — trend kırılınca kapanır',
    riskDeadzone: 'Ölü Bölge:{v}',
    riskCooldown: 'Cooldown:{v}dk',
  },
  login: {
    googleFailed: 'Google ile giriş başarısız. Lütfen tekrar deneyin.',
    tfaSetupRequired: 'Hesabınız için iki adımlı doğrulama zorunlu. Devam etmek için şimdi kurun.',
    tfaCancel: 'Vazgeç',
    accountBlocked: 'Hesabınız engellenmiştir. Destek için yöneticiyle iletişime geçin.',
    loginFailed: 'Giriş başarısız',
    registerFailed: 'Kayıt başarısız',
    serverUnreachable: 'Sunucuya bağlanılamadı',
    greeting: 'Merhaba,',
    login: 'Giriş yap',
    register: 'Hesap Oluştur',
    or: 'veya',
    loginTab: 'Giriş Yap',
    registerTab: 'Hesap Oluştur',
    loginIdPlaceholder: 'E-Posta Adresi veya Kullanıcı Adı',
    passwordPlaceholder: 'Şifre',
    forgotPassword: 'Şifremi Unuttum',
    loggingIn: 'GİRİŞ YAPILIYOR…',
    loginButton: 'GİRİŞ YAP',
    fullNamePlaceholder: 'Ad Soyad',
    emailPlaceholder: 'E-Posta Adresi',
    passwordHint: 'Şifre en az 10 karakter olmalı, en az bir harf ve bir rakam içermelidir.',
    consent1: 'Kimlik, iletişim ve pazarlama verilerimin tercih ettiğim iletişim kanalları üzerinden reklam, promosyon ve ticari elektronik ileti gönderilmesi amacıyla işlenmesini kabul ediyorum.',
    consentEmail: 'E-Posta',
    consentSms: 'SMS/Arama',
    consent2: 'Kimlik, iletişim, müşteri işlem ve pazarlama verilerimin profilleme ve analiz faaliyetleri dahil kullanım alışkanlıklarıma ve ihtiyaçlarıma göre özelleştirilmiş ürün ve hizmetlerin sunulması amacıyla işlenmesine açık rıza veriyorum.',
    platformNoticeTitle: '🛡 TrendSniper Güvenceleri',
    platformNoticeItem1: 'Bu site kesinlikle yatırım tavsiyesi vermez.',
    platformNoticeItem2: 'Yatırımlarınızı, sizin seçtiğiniz stratejiler dışında asla kullanmaz veya yönetmez.',
    platformNoticeItem3: 'OKX TR ve OKX Global borsalarındaki hesaplarınızı kullanarak izinsiz işlem yapmaz.',
    platformNoticeItem4: 'Sizden abonelik ücreti dışında hiçbir ücret talep etmez.',
    kvkkModalTitle: 'Kişisel Verilerimin İşlenmesine İlişkin Aydınlatma Metni',
    agreeKvkkPost: "'ni okudum ve kabul ediyorum.",
    termsModalTitle: 'Kullanım Koşulları',
    agreeTermsMid: "'nı ve",
    privacyModalTitle: 'Gizlilik Politikası',
    agreeTermsPost: "'nı okudum, kabul ediyorum.",
    mustAcceptLegal: 'Devam etmek için Aydınlatma Metni ve Kullanım Koşulları/Gizlilik Politikası onaylarını işaretlemelisiniz.',
    registering: 'KAYDEDILIYOR…',
    registerButton: 'HESAP OLUŞTUR',
    continueWithGoogle: 'Google ile devam et',
  },
  tradeHistory: {
    title: 'İşlem Geçmişi',
    buyLabel: 'AL',
    report: '📊 Rapor',
    deleteSelected: '🗑 Seçilenleri Sil ({n})',
    deleteAll: '🗑 Tümünü Sil',
    refresh: '↻ Yenile',
    searchPlaceholder: 'Parite ara…',
    allSides: 'Tüm Yönler',
    allStatuses: 'Tüm Durumlar',
    clearFilters: '✕ Temizle',
    noTrades: 'Henüz işlem yok.',
    noFilterMatch: 'Filtreyle eşleşen işlem yok.',
    colSymbol: 'Parite',
    colSide: 'Yön',
    colEntry: 'Giriş',
    colExit: 'Çıkış',
    colSl: 'SL',
    colTp: 'TP',
    colPnl: 'P&L',
    colFee: 'Fee',
    colMargin: 'Marjin',
    colLeverage: 'Kaldıraç',
    colAnalysisPeriod: 'AP',
    colAnalysisPeriodTitle: 'Analiz Periyodu',
    colSignal: 'Sinyal',
    colStatus: 'Durum',
    colOpenCloseTime: 'A/K Zamanı',
    colOpenCloseTimeTitle: 'Açılış / Kapanış Zamanı',
    watching: 'İzleniyor',
    clickToWatch: 'Canlı izlemek için tıkla',
    visualizeTitle: 'İşlemi görselleştir (gerçek OKX verisiyle)',
    rowsPerPage: '{n} satır',
    total: '(toplam {n})',
    deleteConfirm: '{label} silinecek. Emin misiniz?',
    deleteConfirmAll: 'tüm işlem geçmişi',
    deleteConfirmSelected: '{n} işlem',
  },
  reportModal: {
    title: 'Raporlar',
    tradeCount: '{n} işlem',
    tabHistory: 'İşlem Geçmişi',
    tabAnalytics: 'Analiz Raporu',
    allPairs: 'Tüm Pariteler',
    allSides: 'Tüm Yönler',
    allStatuses: 'Tüm Durumlar',
    closed: 'Kapalı',
    open: 'Açık',
    signalPlaceholder: 'Sinyal tipi…',
    real: 'Gerçek',
    test: 'Test',
    all: 'Tümü',
    reset: 'Sıfırla',
    loading: 'Yükleniyor…',
    noFilterMatch: 'Filtrele uygun işlem yok.',
    noData: 'Veri yok',
    statTrades: 'İşlem',
    statWinRate: 'Kazanma Oranı',
    statTotalPnl: 'Toplam P&L',
    statTotalFee: 'Toplam Fee',
    statProfitFactor: 'Profit Factor',
    statAvgDuration: 'Ort. Süre',
    colSymbol: 'Parite',
    colSide: 'Yön',
    colEntry: 'Giriş',
    colExit: 'Çıkış',
    colSl: 'SL',
    colTp: 'TP',
    colFee: 'Fee',
    colMargin: 'Marjin',
    colLeverage: 'Kaldıraç',
    colSignal: 'Sinyal',
    colStatus: 'Durum',
    colDate: 'Tarih',
    colDuration: 'Süre',
    metricTotalTrades: 'Toplam İşlem',
    metricWins: 'Kazanan',
    metricLosses: 'Kaybeden',
    metricWinRate: 'Kazanma Oranı',
    metricNetPnl: 'Net P&L ($)',
    metricProfitFactor: 'Profit Factor',
    metricAvgWin: 'Ort. Kazanç ($)',
    metricAvgLoss: 'Ort. Kayıp ($)',
    metricAvgDuration: 'Ort. Süre',
    metricTotalFee: 'Toplam Fee ($)',
    cumPnlTitle: 'Kümülatif P&L ($)',
    sideBreakdownTitle: 'Yön Bazlı P&L',
    best: 'En İyi:',
    worst: 'En Kötü:',
    symbolBreakdownTitle: 'Parite Bazlı P&L',
    minutesShort: '{n} dk',
    hoursMinutesShort: '{h}s{m}dk',
  },
  chart: {
    rsi50Note: ' (50 seviyesi)',
    rsimaRefNote: ' (referans)',
    entry: 'Giriş',
    periodTitle: 'Mum periyodu',
    drawTrend: 'Trend Çizgisi',
    drawRange: 'Fiyat Aralığı',
    drawHLine: 'Yatay Çizgi',
    drawVLine: 'Dikey Çizgi',
    drawClearAll: 'Çizimleri temizle',
    longShortRatio: 'Long/Short Oranı (Piyasa Geneli, OKX)',
    resetButton: '↺ Sıfırla',
    resetTitle: 'Grafik Görünümünü Sıfırla',
    hmaDirection: 'HMA Yön:',
    up: 'YUKARI',
    down: 'AŞAĞI',
    akPct: 'A/K(%)',
    akVal: 'A/K(Değer)',
    mmPct: 'Maks/Min(%)',
    mmVal: 'Maks/Min(Değer)',
    dragTpTitle: "Sürükleyerek TP'yi değiştir (sadece manuel işlem)",
    dragSlTitle: "Sürükleyerek SL'i değiştir (sadece manuel işlem)",
    tpSlUpdateFailed: 'TP/SL güncellenemedi',
  },
  tradeChartModal: {
    interval1D: '1G',
    strategyManual: 'Manuel',
    fetchFailed: 'Grafik verisi alınamadı',
    loading: 'Yükleniyor…',
    noCandles: 'Bu zaman aralığı için mum verisi bulunamadı.',
    visualizationTitle: 'İşlem Görselleştirmesi',
    strategyLabel: 'Strateji:',
    periodLabel: 'Periyot:',
    entryLabel: 'Giriş:',
    exitLabel: 'Çıkış:',
    entryLineLabel: 'Giriş',
    exitLineLabel: 'Çıkış',
    decisionRsiEntry: 'Karar anı RSI (gerçek işlem fiyatında):',
    decisionRsiExit: 'Çıkış anı RSI (gerçek işlem fiyatında):',
    checkpointNote: 'ℹ️ Alttaki RSI/SMA çizgisi mum kapanışı bazlıdır (grafik referansı). Bu strateji mum kapanışını beklemez — giriş/çıkış genellikle mumun İÇİNDE (low/high\'ında) gerçekleşir; o anın gerçek karar değeri yukarıda "Karar anı RSI" olarak ayrıca gösterilir.',
    rsimaRefNote: ' (referans)',
    resetTitle: 'Tam aralığı göster',
    play: 'Oynat',
    pause: 'Duraklat',
    restart: 'Baştan (durdur)',
    entryMoment: 'Giriş anı',
    exitMoment: 'Çıkış anı',
    playbackSpeed: 'Oynatma hızı',
    entryBadge: '🟢 GİRİŞ ANI —',
    exitBadge: '🔴 ÇIKIŞ ANI —',
    narrativeTitle: 'Açıklama',
    narrativeContext: 'Bağlam',
    narrativeEntry: 'Giriş Anı',
    narrativeProcess: 'Pozisyon Süreci',
    narrativeExit: 'Çıkış',
    sideLong: 'LONG (alış)',
    sideShort: 'SHORT (satış)',
    days: '{n} gün',
    hoursShort: '{n} sa',
    minutesShort2: '{n} dk',
    configUsed: 'Kullanılan parametreler: {list} (belirtilmeyenler platform varsayılanını kullandı).',
    configDefault: 'Hiçbir parametre özelleştirilmedi — tamamı platform varsayılan değerleriyle çalıştırıldı.',
    configUnknown: 'Bu işlemde kullanılan tam parametre seti canlı işlem kayıtlarında ayrıca saklanmıyor.',
    contextText: '{symbol} paritesi, {interval} periyot, "{strategy}" stratejisi. {config}',
    entryBase: '{time} tarihinde {price} fiyatından {side} pozisyon açıldı.',
    entryTrendUp: 'yükseliş trendinde (MA50 > MA200)',
    entryTrendDown: 'düşüş trendinde (MA50 < MA200)',
    entryTrendPullback: ' Giriş anında piyasa {trend} idi (MA50 {ma50}, MA200 {ma200}); fiyat MA50\'ye yeterince yakın olduğu (pullback koşulu) ve RSI ({rsi}) momentum eşiğini desteklediği için tetiklendi.',
    entryTrendPullbackFallback: ' Trend (MA50/MA200) ve pullback koşulu sağlandığı için tetiklendi.',
    entryHmaAdx: ' Bu strateji durum-tabanlıdır: flat kaldığı HER anda o anki HMA yönünde anında pozisyon açar — flip beklemez.{adxNote}',
    entryHmaAdxNote: ' Giriş anında ADX {adx} idi.',
    entryRsi50Cp: ' Kararın gerçek dayanağı, mum kapanışını beklemeyen "karar anı" RSI değeriydi: RSI {rsi} — 50 orta bandının dışına ilk çıktığı an tetiklendi.',
    entryRsi50Fallback: ' RSI, 50 orta bandının dışına ilk çıktığı an tetiklendi.',
    entryRsimaCp: ' Karar anında RSI ({rsi}) ile SMA ({rsiMa}) karşılaştırıldı — {cmp} olduğu için giriş koşulsuz ve anında gerçekleşti.',
    entryRsimaCpLong: "RSI, SMA'ya eşit ya da üzerinde",
    entryRsimaCpShort: "RSI, SMA'nın altında",
    entryRsimaFallback: ' RSI/SMA karşılaştırmasıyla koşulsuz ve anında tetiklendi.',
    entryRsima50: ' Karar mumunun kapanışında SMA (RSI\'ün 14 periyotluk ortalaması) {rsiMa} idi — {cmp} olduğu için giriş gerçekleşti.',
    entryRsima50Long: "SMA, Ölü Bölge bandının üzerinde",
    entryRsima50Short: "SMA, Ölü Bölge bandının altında",
    entryRsima50Fallback: ' Mum kapanışında SMA, önce Ölü Bölge\'ye uğradıktan sonra bandın dışına çıktığı için tetiklendi.',
    processStillOpen: 'Pozisyon şu anda hâlâ açık — henüz kapanmadı.',
    processSlHit: 'Pozisyon, açılıştaki sabit Stop Loss seviyesine çarpana kadar {duration} açık kaldı — SL giriş sonrası hiç değişmedi.',
    processTrendReversal: 'Pozisyon {duration} açık kaldıktan sonra MA50/MA200 trend ilişkisi tersine döndü; sistem bunu bir güvenlik sinyali olarak algılayıp trailing/SL beklemeden anında kapattı.',
    processGeneric: 'Pozisyon {duration} açık kaldı.',
    processHmaReversal: 'Pozisyon {duration} boyunca açık kaldı; TP olmadığı için (sadece sabit SL yedek sigortasıyla) HMA aynı yönde kaldığı sürece taşındı, sonunda HMA tersine dönünce hemen kapatıldı.',
    processHmaSl: 'Pozisyon {duration} açık kaldı, Stop Loss yedek sigortası tetiklenene kadar sabit kaldı.',
    processRsi50Generic: 'Pozisyon, RSI tekrar 50 orta bandına dönene (ya da SL/TP tetiklenene) kadar {duration} açık kaldı.',
    processRsimaGeneric: 'Pozisyon, RSI mevcut tarafın SMA±Ölü Bölge tamponunu tam geçene (ya da SL tetiklenene) kadar {duration} açık kaldı.',
    processRsima50Generic: 'Pozisyon, SMA Ölü Bölge\'ye geri dönene ya da sabit SL\'e çarpana kadar {duration} açık kaldı.',
    exitBase: '{time} tarihinde {price} fiyatından kapandı.',
    exitReasonSuffix: ' Kapanış sebebi: {reason}.',
    exitResultSuffix: ' Sonuç: {result} ({pnl}).',
    resultProfit: 'KÂR',
    resultLoss: 'ZARAR',
    exitReasonSlHit: 'Zarar Durdur (SL) seviyesine ulaşıldığı için kapandı',
    exitReasonTrailingSl: 'Kâr yönünde ilerlemiş SL (trailing stop) tetiklendiği için KÂRLI kapandı',
    exitReasonTpHit: 'Kâr Al (TP) hedefine ulaşıldığı için kapandı',
    exitReasonTrendReversalPullback: "MA50, MA200'ün karşı tarafına geçtiği (trend tersine döndüğü) için güvenlik amaçlı hemen kapatıldı",
    exitReasonTrendReversalHma: 'HMA yönü tersine döndüğü için kapatıldı (aynı anda {side} yönünde yeni pozisyon açıldı)',
    exitReasonRsi50Deadzone: 'RSI, 50 orta bandına (ölü bölgeye) geri döndüğü için kapandı',
    exitReasonRsi50Extreme: 'RSI aşırı alım/satım bölgesinden geri çekildiği için (TP trailing) kapandı',
    exitReasonRsimaExit: 'RSI, SMA referans çizgisinin karşı tarafına geçtiği için kapandı',
    exitReasonRsima50Deadzone: 'SMA, Ölü Bölge bandına geri döndüğü için kapandı',
    exitReasonBacktestEnd: "Backtest'in veri aralığı sona erdiği için son fiyattan işaretlenerek kapatıldı — gerçek bir strateji sinyali değil",
    exitReasonSlExternal: 'OKX tarafında kapandığı tespit edildi, zararlı sonuçlandığı için muhtemelen Zarar Durdur (SL) tetiklendi (kesin mekanizma OKX geçmişinden doğrulanamıyor)',
    exitReasonTpExternal: 'OKX tarafında kapandığı tespit edildi, kârlı/nötr sonuçlandığı için muhtemelen Kâr Al (TP) hedefine ulaşıldı (kesin mekanizma OKX geçmişinden doğrulanamıyor)',
    exitReasonBotStopped: 'Bot kullanıcı tarafından durdurulduğu için açık pozisyon otomatik kapatıldı',
    exitReasonManual: 'Kullanıcı tarafından manuel olarak kapatıldı',
  },
  logViewer: {
    title: 'Backend Logları',
    lineCount: '{visible} / {total} satır',
    filterAll: 'Tümü',
    filterAnalysis: 'Analiz',
    filterTrade: 'İşlem',
    filterBot: 'Bot',
    filterReconcile: 'Reconcile',
    filterError: 'Hata',
    searchPlaceholder: 'Ara…',
    resume: 'Devam et',
    pause: 'Duraklat',
    clear: 'Temizle',
    clearButton: '✕ Temizle',
    empty: 'Henüz log yok…',
    scrollToBottom: '↓ En alta git',
  },
  walletTransfer: {
    infoNote: 'OKX\'te ayrı bir "spot" ve "vadeli" cüzdanı yoktur — Fon hesabı yatırma/çekme içindir, İşlem hesabı ise botun (spot veya vadeli fark etmeksizin) pozisyon açarken kullandığı ortak bakiyedir. Aralarında USDT taşıyabilirsiniz.',
    balancesFailed: 'Bakiyeler alınamadı',
    detailFailed: 'Detay alınamadı',
    invalidAmount: 'Geçerli bir tutar girin',
    flipDirection: 'Yönü değiştir',
    refreshBalances: 'Bakiyeleri yenile',
    hideDetail: '▾ Bakiye detayını gizle',
    showDetail: '▸ Bakiye neden bu kadar? (detay)',
    loading: 'Yükleniyor…',
    totalEquity: 'Toplam özkaynak (İşlem)',
    availableForOrders: 'Yeni emir için kullanılabilir',
    lockedInPositions: 'Açık pozisyon/algo emirde kilitli',
    lockedInPendingOrders: 'Bekleyen limit emirde kilitli',
    openPositionsTitle: 'Marjin kilitleyen açık pozisyonlar',
    noOpenPositions: 'Açık vadeli pozisyon yok — kullanılabilir tutar ile toplam özkaynak arasındaki fark varsa bekleyen emirlerden kaynaklanıyordur.',
    allAssetsTitle: 'Varlıklarım',
    convertInfoNote: 'USDTTRY bir "pozisyon" değil, TRY ile USDT arasında dönüşüm yapmanın aracıdır — diğer paritelerin (BTCUSDT, BTCTRY gibi) aksine kâr amaçlı bir işlem değildir. Aşağıdan İşlem hesabınızdaki USDT/TRY bakiyenizi birbirine dönüştürebilirsiniz.',
    convertFailed: 'Dönüşüm başarısız',
    convertSuccess: '✓ Dönüşüm tamamlandı.',
    converting: 'Dönüştürülüyor…',
    convertButton: 'Dönüştür ({direction})',
    directionTryToUsdt: 'TRY → USDT',
    directionUsdtToTry: 'USDT → TRY',
  },
  liveStatus: {
    title: 'Canlı Durum',
    currentPrice: 'Anlık Fiyat',
    candleClose: 'mum kapanışı',
    floatingPnl: 'Floating Pnl:',
    marketRegime: 'Piyasa Rejimi (CHOP)',
    threshold: 'Eşik:',
    chopSuppressed: ' — Yatay, sinyal bastırılıyor',
    chopTrend: ' — Trend, filtre açık değil',
    eventLog: 'Olay Günlüğü',
    noEvents: 'Henüz olay yok',
    openPositions: 'Açık Pozisyonlar',
    spotSuffix: '(Spot)',
    hmaDirection: 'HMA Yönü',
    rangeBarSuffix: ' (range bar)',
    up: '▲ YUKARI',
    down: '▼ AŞAĞI',
    box: 'Box:',
    barSuffix: 'bar',
    adxThresholdSuffix: ' (eşik: {v})',
    adxInfoSuffix: ' (bilgi)',
    filterPassed: 'Filtre geçti',
    filterBlocking: '< {v} — filtre engelliyor',
    filterOff: 'Filtre devre dışı',
    rsimaLabel: 'RSI (koşulsuz/anlık, TP yok, flip tamponu)',
    longRsiRsima: '▲ LONG (RSI≥SMA)',
    shortRsiRsimaSpot: '— RSI<SMA (spotta short yok)',
    shortRsiRsima: '▼ SHORT (RSI<SMA)',
    blockedShortSpotRsima: 'Flat — spot modda short açılamaz, RSI≥SMA (LONG) olunca hemen açılır',
    instantOpenRsima: 'Flat — RSI vs SMA\'ya göre hemen açılır (bekleme yok)',
    buffer: 'Tampon: {v} (SMA±{dz}) — geçince kapat+flip (SL her zaman aktif)',
    rsima50Label: 'SMA (RSI\'nin 14 periyotluk ortalaması, sadece mum kapanışı)',
    longRsima50: '▲ LONG (SMA≥50)',
    shortRsima50Spot: '— SMA<50 (spotta short yok)',
    shortRsima50: '▼ SHORT (SMA<50)',
    blockedShortSpotRsima50: 'Flat — spot modda short açılamaz, SMA önce Ölü Bölge\'ye uğrayıp üstüne (LONG) çıkınca açılır',
    instantOpenRsima50: 'Flat — SMA önce Ölü Bölge\'ye uğramalı, bandın dışına çıktığı mum kapanışında açılır',
    rsima50ExitNote: 'Çıkış: SMA Ölü Bölge bandına döndüğü mum kapanışında kapat (SL yedek sigorta)',
    rsiMaRef: 'SMA (referans)',
    trendLabel: 'Trend (MA50/MA200)',
    uptrend: '▲ Yükseliş (MA50>MA200)',
    downtrend: '▼ Düşüş (MA50<MA200)',
    waitingNewPullback: '⏳ Yeni pullback bekleniyor — önce fiyatın bandın dışına çıkması, sonra tekrar yaklaşması gerekiyor (aynı bölgede art arda giriş engelleniyor)',
    blockedShortSpotTrend: 'Flat — spot modda short açılamaz, yükseliş trendi bekleniyor',
    signalLabel: 'Sinyal: {v}',
    waiting: 'Bekleniyor',
    trendPullbackExitNote: 'SL: {v} (yedek sigorta) — trend tersine dönünce kapanır, sabit TP yok',
    adxRsiMomentum: 'RSI Momentum Eşiği: {v}',
  },
  userManager: {
    subActive: 'Aktif',
    subTrial: 'Deneme',
    subInactive: 'Pasif',
    subCancelled: 'İptal',
    blocked: 'Engelli',
    back: '← Geri',
    fullName: 'Ad Soyad',
    subscriptionStatus: 'Abonelik Durumu',
    subStart: 'Abonelik Başlangıç',
    subEnd: 'Abonelik Bitiş',
    expired: 'Süresi doldu',
    daysLeft: '{n} gün kaldı',
    accountStatus: 'Hesap Durumu',
    active: '✓ Aktif',
    blockedBtn: '⊘ Engelli',
    notes: 'Notlar',
    notesPlaceholder: 'Admin notu (isteğe bağlı)…',
    newPassword: 'Yeni Şifre',
    changePlaceholder: '(değiştirmek için girin)',
    okxApiKeysHeader: 'OKX BAĞLANTI DURUMU',
    okxInfoOnly: 'Sadece bilgi amaçlıdır — API kimlik bilgilerini admin göremez/değiştiremez, sadece bağlantının çalışıp çalışmadığını test edebilir.',
    baseUrl: 'Base URL',
    testConnection: 'Test Et',
    testing: 'Test ediliyor…',
    testValid: '✓ Bağlantı çalışıyor',
    testInvalid: '✕ API bilgisi girilmiş ama geçersiz/reddedildi',
    testMissing: '✕ API bilgisi hiç girilmemiş',
    saved: 'Kaydedildi',
    saveError: 'Kayıt hatası',
    saving: 'Kaydediliyor…',
    save: 'Kaydet',
    confirmDeleteBulk: '{n} kullanıcı silinsin mi?',
    confirmDeleteSingle: '"{email}" silinsin mi?',
    confirmDeleteSub: 'Bu işlem geri alınamaz. Mevcut oturumlar kapatılır.',
    cancel: 'İptal',
    delete: 'Sil',
    systemAccessTitle: 'Sistem Erişimi (Admin / Viewer)',
    adminUsername: 'Admin Kullanıcı',
    adminPassword: 'Admin Şifre',
    viewerUsername: 'Viewer Kullanıcı',
    viewerPassword: 'Viewer Şifre',
    registeredUsers: 'Kayıtlı Kullanıcılar',
    refresh: 'Yenile',
    searchPlaceholder: 'Ad veya e-posta ara…',
    all: 'Tümü',
    selectedCount: '{n} seçili',
    activateBulk: '✓ Aktifleştir',
    blockBulk: '⊘ Engelle',
    changeSubscription: 'Abonelik değiştir…',
    apply: 'Uygula',
    deleteBulk: '✕ Sil',
    clearSelection: 'Seçimi temizle',
    colUser: 'Kullanıcı',
    colSubscription: 'Abonelik',
    colEnd: 'Bitiş',
    loading: 'Yükleniyor…',
    noUsers: 'Henüz kayıtlı kullanıcı yok',
    noFilterMatch: 'Filtreye uyan kullanıcı bulunamadı',
    daysLeftShort: '{n}g',
    expiredShort: 'Doldu',
    editTitle: 'Düzenle',
    deleteTitle: 'Sil',
  },

  support: {
    title: 'Destek Talepleri',
    myTickets: 'Taleplerim',
    allTickets: 'Tüm Talepler',
    createButton: '+ Yeni Talep Oluştur',
    subjectLabel: 'Konu',
    subjectPlaceholder: 'Sorununuzu kısaca özetleyin',
    categoryLabel: 'Kategori',
    messageLabel: 'Mesaj',
    messagePlaceholder: 'Sorununuzu detaylıca açıklayın…',
    submitButton: 'Talep Oluştur',
    cancelButton: 'Vazgeç',
    catTechnical: 'Teknik Sorun',
    catAccount: 'Hesap / Üyelik',
    catBilling: 'Ödeme / Abonelik',
    catBot: 'Bot / Strateji',
    catOther: 'Diğer',
    statusOpen: 'Açık',
    statusInProgress: 'İşlemde',
    statusResolved: 'Çözüldü',
    statusClosed: 'Kapalı',
    statusFilterAll: 'Tüm Durumlar',
    noTickets: 'Henüz talebiniz yok.',
    noTicketsAdmin: 'Hiç destek talebi yok.',
    messageCount: '{n} mesaj',
    lastMessage: 'Son mesaj {time}',
    backToList: '← Listeye Dön',
    replyPlaceholder: 'Yanıtınızı yazın… (Enter ile gönder, Shift+Enter yeni satır)',
    sendButton: 'Gönder',
    closeTicketButton: 'Talebi Kapat',
    confirmClose: 'Bu talebi kapatmak istediğinize emin misiniz? Kapatılan talebe yeni mesaj yazılamaz.',
    closedNotice: 'Bu talep kapatılmıştır.',
    supportTeamLabel: 'Destek Ekibi',
    you: 'Siz',
    loadFailed: 'Talepler yüklenemedi',
    createFailed: 'Talep oluşturulamadı',
    sendFailed: 'Mesaj gönderilemedi',
    userColumn: 'Kullanıcı',
  },

  home: {
    navFeatures: 'Özellikler',
    navStrategies: 'Stratejiler',
    navWorkflow: 'Nasıl Çalışır',
    ctaLogin: 'Giriş',

    eyebrow: 'OKX Vadeli İşlemler · Otomatik Long/Short Bot',
    heroTitleBefore: 'Sinyal oluştuğu andan ',
    heroTitleHighlight: 'pozisyon kapanana kadar',
    heroTitleAfter: ' botunuz nöbette',
    heroLead: 'TrendSniper; MA50/RSI tabanlı stratejilerle OKX Vadeli İşlemler hesabınızda otomatik Long/Short pozisyon açar, risklerinizi yönetir ve tüm süreci canlı olarak izlemenizi sağlar.',
    ctaExplore: 'Özellikleri İncele',
    ctaBuy: 'Satın Al',

    chip1: 'Otomatik Long/Short',
    chip2: 'OKX Global & OKX TR',
    chip3: 'Backtest & Sweep',
    chip4: 'Test/Simülasyon Modu',
    chip5: 'Sürükle-Bırak TP/SL',
    chip6: 'TR/EN · Açık/Koyu Tema',

    ticketLabel: 'AÇIK İŞLEM',
    ticketSymbol: 'BTC-USDT-SWAP',
    ticketSide: 'LONG',
    ticketStrategyLabel: 'Strateji',
    ticketStrategyValue: 'Trend-Pullback + R',
    ticketLeverageLabel: 'Kaldıraç',
    ticketLeverageValue: '10x',
    ticketEntryLabel: 'Giriş Fiyatı',
    ticketStatusLabel: 'Durum',
    ticketStatusValue: 'İzleniyor',
    ticketPnlLabel: 'Anlık PNL',

    featuresTitle: 'Tek panelden yönetin',
    featuresLead: 'Sinyalden pozisyon kapanışına kadar tüm süreç, tek bir panelden kontrol edilir.',
    feature1Title: 'Otomatik Long/Short Bot',
    feature1Desc: 'Strateji, ayarlar kaydedilirken kilitlenir; bot bu anlık görüntüyle çalışır, durdurulduğunda pozisyonu otomatik kapatır.',
    feature2Title: 'OKX Global & OKX TR',
    feature2Desc: 'İki OKX hesap bölgesi de bağımsız API anahtarlarıyla desteklenir; Spot ve Vadeli İşlemler piyasalarında çalışabilirsiniz.',
    feature3Title: '4 Hazır Strateji',
    feature3Desc: 'Range Bar+HMA+ADX, RSI+SMA, Trend-Pullback+R ve SMA-50 Seviyesi — her biri kendi risk kurallarıyla parametrelenebilir.',
    feature4Title: 'Backtest, Sweep & Walk-Forward',
    feature4Desc: 'Canlıya geçmeden önce tek test, parametre taraması veya walk-forward doğrulamasıyla stratejinizi geçmiş veri üzerinde sınayın.',
    feature5Title: 'Test/Simülasyon Modu',
    feature5Desc: 'Gerçek para riske atmadan, abonelik gerektirmeden sınırsız deneme yapabileceğiniz tam işlevli bir simülasyon modu.',
    feature6Title: 'Manuel İşlem & Sürükle-Bırak TP/SL',
    feature6Desc: 'Bottan bağımsız manuel pozisyon açın; TP/SL seviyelerini doğrudan grafik üzerinde sürükleyerek anlık ayarlayın.',
    feature7Title: 'Canlı Grafik & Durum Paneli',
    feature7Desc: 'MA50/MA200, RSI/SMA ve stratejiye özel HMA/ADX katmanlarını WebSocket üzerinden gerçek zamanlı izleyin.',
    feature8Title: 'Risk Yönetimi',
    feature8Desc: 'ATR veya yüzde bazlı SL/TP, stop sonrası bekleme (cooldown) ve minimum ödül:risk kontrolleriyle pozisyonlarınız korunur.',
    feature9Title: 'Çoklu Kullanıcı İzolasyonu',
    feature9Desc: 'Her kullanıcı kendi API anahtarı, ayarları ve işlem geçmişiyle tam izole çalışır; deneme/aktif abonelik katmanları desteklenir.',
    feature10Title: 'TR/EN & Açık/Koyu Tema',
    feature10Desc: 'Tüm arayüz Türkçe/İngilizce ve açık/koyu tema seçenekleriyle, her cihazda aynı hızda çalışır.',

    strategiesTitle: 'Dört hazır strateji, dört farklı piyasa okuması',
    strategiesLead: 'Her strateji kilitli bir anlık görüntüyle çalışır; parametreler backtest ile önceden sınanabilir.',
    strategy1Name: 'Range Bar+HMA+ADX',
    strategy1Desc: 'Range bar mumları üzerinde Hull MA yön değişimini, ADX trend gücü filtresiyle birlikte değerlendirir.',
    strategy2Name: 'RSI+SMA',
    strategy2Desc: 'RSI ile hareketli ortalamasının (SMA) kesişimini izler; SMA etrafındaki tampon bölge yönü ne zaman değiştireceğini (flip) belirler.',
    strategy3Name: 'Trend-Pullback+R',
    strategy3Desc: 'MA50/MA200 trend yönü, fiyatın MA50\'ye geri çekilmesi ve RSI momentum onayının üçünü birlikte arar.',
    strategy4Name: 'SMA-50 Seviyesi',
    strategy4Desc: 'SMA\'nın 50 seviyesi etrafındaki ölü bölgeye uğrayıp dışına çıkmasını net, basit kurallı bir giriş sinyali sayar.',

    workflowTitle: 'Bot süreci baştan sona',
    workflowLead: 'Sinyalden rapora kadar her adım otomatik işler; siz sadece stratejiyi ve risk parametrelerini belirlersiniz.',
    step1Status: 'Sinyal Tespiti',
    step1Desc: 'Seçilen strateji canlı mum verisini sürekli tarar; giriş koşulları oluştuğunda sinyal üretir.',
    step2Status: 'Pozisyon Açılışı',
    step2Desc: 'Bot, kilitli ayarlarınıza (kaldıraç, marj, SL/TP) göre OKX hesabınızda Long/Short pozisyon açar.',
    step3Status: 'Risk Yönetimi',
    step3Desc: 'ATR/yüzde bazlı SL-TP, minimum ödül:risk ve cooldown kuralları pozisyon açık kaldığı sürece izlenir.',
    step4Status: 'Kapanış & Rapor',
    step4Desc: 'Pozisyon TP/SL veya yapısal çıkışla kapanır; işlem geçmişine ve detaylı raporlara otomatik işlenir.',

    trustTitle: 'Kontrol her zaman sizde',
    trustItem1: 'TrendSniper hiçbir zaman yatırım tavsiyesi vermez; tüm strateji ve risk kararları size aittir.',
    trustItem2: 'İzniniz dışında hiçbir işlem açılmaz, hiçbir ücret alınmaz.',
    trustItem3: 'Tüm işlemler kendi OKX hesabınızda, kendi API anahtarlarınızla gerçekleşir — bakiyeniz bizde tutulmaz.',
    trustItem4: 'Test/Simülasyon modunda gerçek para hiçbir zaman riske girmez.',

    ctaBannerTitle: 'Stratejinizi bugün test modunda deneyin',
    ctaBannerLead: 'Kayıt olun, gerçek para riske atmadan sınırsız test/simülasyon işlemi yapın.',
    ctaBannerButton: 'Giriş',

    footerTagline: 'OKX Vadeli İşlemler için sinyal tabanlı otomatik alım-satım platformu.',
    footerProductHeading: 'Ürün',
    footerCorporateHeading: 'Kurumsal',
    footerAbout: 'Hakkımızda',
    footerContact: 'İletişim',
    footerPrivacy: 'Gizlilik Politikası',
    footerKvkk: 'KVKK Aydınlatma Metni',
    footerTerms: 'Kullanım Şartları',
    footerRights: '© {year} TrendSniper. Tüm hakları saklıdır.',
    footerBuiltBy: 'tarafından geliştirilmiştir.',
  },
  sms: {
    note: 'NetGSM üzerinden yalnızca sistem mesajları gönderilir: güvenlik bildirimleri ve iki adımlı doğrulama kodları (OTP hesabı). Şifreler kaydedildikten sonra gösterilmez.',
    netgsmTitle: 'NetGSM Bilgileri',
    username: 'Kullanıcı Adı',
    header: 'Gönderici Adı (Başlık)',
    otpPassword: 'OTP Şifresi (doğrulama kodları ve güvenlik bildirimleri)',
    individualPassword: 'Bireysel Şifresi (ticari)',
    merchantPassword: 'Tacir Şifresi (ticari)',
    passwordSet: 'Tanımlı',
    passwordNotSet: 'Tanımlı değil',
    keepPlaceholder: 'Değiştirmek için yeni şifreyi yazın',
    clear: 'Sil',
    clearConfirm: 'Bu şifre silinsin mi?',
    iysNote: 'Bireysel/Tacir ticari hesaplardır: İYS onayı olmayan numaraya iletilmez ama NetGSM yine başarılı döner.',
    saved: 'SMS ayarları kaydedildi.',
    testTitle: 'Test SMS ve Kalan SMS Adedi',
    testSend: 'Test SMS Gönder',
    testSent: 'Test SMS gönderildi.',
    testViaFallback: '(OTP paketi olmadığı için normal hattan gönderildi)',
    testFailed: 'Test SMS gönderilemedi.',
    balance: 'Kalan SMS Adedi',
    balanceFailed: 'Bakiye sorgulanamadı.',
    logTitle: 'SMS Gönderim Raporu',
    allStatuses: 'Tüm durumlar',
    sent: 'Gönderildi',
    failed: 'Başarısız',
    logSummary: '{sent} gönderildi, {failed} başarısız',
    colDate: 'Tarih',
    colPurpose: 'Amaç · Hesap',
    colPhone: 'Telefon',
    colStatus: 'Durum',
    colDetail: 'Ayrıntı',
    noLogs: 'Bu aralıkta kayıt yok.',
    alertTitle: 'Güvenlik Bildirimleri',
    alertHint: 'Art arda hatalı giriş denemesiyle başlayan kilitler, sistem yöneticisi hesabına daha önce görülmemiş bir IP adresinden giriş ve haftalık bağımlılık taramasında bulunan yüksek/kritik açıklar bu numaraya SMS ile bildirilir (OTP hesabı). Boş bırakılırsa SMS gönderilmez, olaylar yalnızca sunucu loguna yazılır.',
    alertPhone: 'Güvenlik bildirim telefonu',
    alertTest: 'Test Bildirimi Gönder',
    alertSaved: 'Güvenlik bildirim telefonu kaydedildi.',
    alertTestSent: 'Test bildirimi gönderildi.',
  },
  tfa: {
    title: 'İki Adımlı Doğrulama',
    enabled: 'Açık',
    methodTotp: 'Doğrulama uygulaması',
    methodSms: 'SMS ({phone})',
    backupRemaining: 'Kalan yedek kod: {n}',
    password: 'Şifreniz (onay için)',
    newBackupCodes: 'Yeni Yedek Kodlar',
    disable: 'Kapat',
    requiredNote: 'İki adımlı doğrulama hesabınız için zorunlu; kapatılamaz.',
    enabledNow: 'İki adımlı doğrulama açıldı.',
    googleExempt: 'Google ile giriş yaptığınız için doğrulama Google hesabınızın kendi iki adımlı doğrulamasıyla yapılır. Google hesabınızda 2 adımlı doğrulamayı açmanızı öneririz.',
    disabledByAdmin: 'İki adımlı doğrulama şu anda sistem yöneticisi tarafından kapalı.',
    policyTitle: 'İki Adımlı Doğrulama (2FA)',
    policyHint: 'Girişte şifreye ek olarak doğrulama uygulamasından (ya da SMS ile) gelen kod istenir. Zorunlu modda kurmamış kullanıcılar bir sonraki girişte kurulum ekranına yönlendirilir. Google ile giriş yapanlar Google hesabının kendi doğrulamasını kullanır. Telefonunu kaybeden kullanıcının 2FA’sını Kullanıcılar sekmesinden sıfırlayabilirsiniz.',
    policyLabel: 'Politika',
    modeOff: 'Kapalı',
    modeOptional: 'İsteğe bağlı (her kullanıcı kendi açar)',
    modeAdmins: 'Sistem yöneticisi için zorunlu',
    modeAll: 'Herkes için zorunlu',
    smsLabel: 'SMS ile kod yöntemine izin ver (NetGSM OTP şifresi gerekir)',
    smsNeedsOtp: 'SMS yöntemi için önce SMS sekmesinden NetGSM OTP şifresini girin.',
    policySaved: '2FA politikası kaydedildi.',
    reset: '2FA Sıfırla',
    resetConfirm: 'Bu kullanıcının iki adımlı doğrulaması sıfırlansın mı? Kullanıcı yeniden kurmak zorunda kalacak.',
    resetDone: 'İki adımlı doğrulama sıfırlandı.',
    puzzleTitle: 'Giriş Yapbozu',
    puzzleHint: 'Girişte parçayı kaydırarak boşluğa yerleştirme doğrulaması. “Şüpheli durumda” seçiliyken yalnızca aynı adresten art arda hatalı denemeler olduğunda gösterilir; normal kullanıcı görmez.',
    puzzleLabel: 'Ne zaman gösterilsin',
    puzzleOff: 'Kapalı',
    puzzleSuspicious: 'Şüpheli durumda (önerilen)',
    puzzleAlways: 'Her girişte',
  },
  backup: {
    note: 'Veritabanı her gece 02:00’da (İstanbul) sunucuya yedeklenir, son 7 yedek tutulur. R2 ayarlıysa aynı yedek şifrelenip sunucu dışına da gönderilir. Geri yükleme bu ekrandan yapılmaz — sistem yöneticisi sunucuda yapar.',
    localTitle: 'Sunucudaki Yedekler',
    now: 'Şimdi Yedekle',
    created: '{file} oluşturuldu.',
    colFile: 'Dosya',
    colDate: 'Tarih',
    colSize: 'Boyut',
    download: 'İndir',
    empty: 'Henüz yedek yok.',
    offsiteTitle: 'Sunucu Dışı Yedek (Cloudflare R2)',
  },
};
